import gql from 'graphql-tag';

import { ClaimViewFields } from '../fragments/claim';

export const UpdateClaim = gql`
  mutation UpdateClaim($input: UpdateClaimInput!) {
    updateClaim(input: $input) {
      result
      errorCode
      claim {
        ...ClaimViewFields
      }
    }
  }
  ${ClaimViewFields}
`;
